import { ReactNode } from 'react';

import { EColor, EFontWeight, ETypographyVariant } from '@core/type';

import { Box } from '../layout/Box';
import { Typography } from '../typography/Typography';

export const AlertHandled = ({ message }: { message?: ReactNode }): JSX.Element => {
  if (message) {
    return (
      <Box
        margin={'0px auto'}
        paddingBottom={12}
        paddingTop={12}
        width={'100%'}
        flexDirection={'column'}
        alignItems={'center'}
        display={'flex'}
      >
        <Typography
          variant={ETypographyVariant.BODY3}
          fontWeight={EFontWeight.REGULAR}
          textAlign={'center'}
          color={EColor.DANGER}
        >
          {message}
        </Typography>
      </Box>
    );
  }

  return null;
};
